/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */

export type SprintFrequency =
  (typeof SprintFrequency)[keyof typeof SprintFrequency];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SprintFrequency = {
  WEEKLY_1: "WEEKLY_1",
  WEEKLY_2: "WEEKLY_2",
  WEEKLY_3: "WEEKLY_3",
  MONTHLY: "MONTHLY",
  WEEKLY_5: "WEEKLY_5",
} as const;
